import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

const Nav = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 16px',
        backgroundColor: isMobile ? 'white' : 'transparent',
        boxShadow: isMobile ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-start',
          alignItems: 'center',
          paddingLeft: isMobile ? '0px' : '70px',
          paddingTop: isMobile ? '0px' : '20px',
        }}
      >
        <Typography variant="h6">
          <Link to="/">
            <img src="/Logo/PBpayNewLogo.png" alt="PBpay" style={{ maxWidth: '100%', height: '80px', width: '140px' }} />
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default Nav;
